import { useState, useCallback } from "react";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { ServiceArea } from "@/components/ServiceArea";
import { FAQ } from "@/components/FAQ";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer, MobileCallBar } from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const [service, setService] = useState("");

  const onBook = useCallback((title) => {
    setService(title);
    scrollToId("quote");
  }, []);

  return (
    <SmoothScroll>
      <div data-testid="home-page" className="relative">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Services onBook={onBook} />
          <Marquee dark />
          <Gallery />
          <Reviews />
          <ServiceArea />
          <FAQ />
          <QuoteForm preselectedService={service} />
        </main>
        <Footer />
        <MobileCallBar />
      </div>
    </SmoothScroll>
  );
}
